import { render } from "./EditChapter.vue?vue&type=template&id=631e5c2e&scoped=true"
import script from "./EditChapter.vue?vue&type=script&lang=js"
export * from "./EditChapter.vue?vue&type=script&lang=js"

import "./EditChapter.vue?vue&type=style&index=0&id=631e5c2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631e5c2e"]])

export default __exports__